import React, { Component } from 'react';

import './Card.css';
import JavaScript from '../images/javascript.png';
import ReactLogo from '../images/react.png';
import webpackLogo from '../images/webpack.png';
import HTMLLogo from '../images/html.png';
import CSSLogo from '../images/css.png';
import ReduxLogo from '../images/redux.png';
import jestLogo from '../images/jest.png';

class CardB extends Component {
    render() {
        return (
            <div className="Card">
                <h2>The OverReacting Quiz </h2>
                <h4>JavaScript, Reactjs, Webpack, Babel, HTML, CSS, Redux and Jest</h4>
                <p>Popular Quiz Game with a twist</p>
                <div className="card-lang">
                    <img src={JavaScript} alt="JavaScript" /> &nbsp;
                    <img src={ReactLogo} alt="React" /> &nbsp;
                    <img src={webpackLogo} alt="Webpack" /> &nbsp;
                    <img src={jestLogo} alt="jest" /> &nbsp;
                    <img src={HTMLLogo} alt="HTM5" /> &nbsp; 
                    <img src={CSSLogo} alt="CSS3" /> &nbsp; 
                    <img src={ReduxLogo} alt="Redux" />
                </div><br />
                <div className="card-nav">
                    <div className="card-nav-left">
                        <a href="https://github.com/FopeA6/OverReacting_Quiz" target="_blank" rel="noopener noreferrer">View Source Code</a>
                    </div>
                    <div className="card-nav-right">
                        <a href="https://overreactingquiz7.netlify.app/" target="_blank" rel="noopener noreferrer">View Project</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardB
